import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import DataListPage from "../../../components/DataListPage";
import TruncatedCell, { TruncatedLink } from "../../../components/TruncatedCell";
import newService from "../../../services/newService";
import { instanceToken } from "../../../utils/constant";

export default function News() {
  const navigate = useNavigate();

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [count, setCount] = useState(0);
  const [news, setNews] = useState(null);

  const parse = useCallback((data) => {
    setNews(data.news);
    setCount(data.count);
  }, []);

  const fetchNews = useCallback(
    async (limit, offset) => {
      try {
        const res = await newService.getNews(instanceToken.token, limit, offset);
        parse(res.data);
      } catch (error) {
        console.error(error);
        throw new Error(error);
      }
    },
    [parse]
  );

  useEffect(() => {
    const calculatedOffset = page * rowsPerPage;
    fetchNews(rowsPerPage, calculatedOffset);
  }, [page, rowsPerPage, fetchNews]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const openDetail = (row) => navigate(`/news/${row.id}`);

  const columns = [
    { id: "id", label: "ID", render: (row) => row.id },
    {
      id: "title_en",
      label: "Title (English)",
      render: (row) => <TruncatedCell value={row.title_en} />,
    },
    {
      id: "title_mm",
      label: "Title (Myanmar)",
      render: (row) => <TruncatedCell value={row.title_mm} myanmar />,
    },
    {
      id: "category",
      label: "Category",
      render: (row) => <TruncatedCell value={row.category} />,
    },
    {
      id: "paragraph_en",
      label: "Paragraph (English)",
      render: (row) => <TruncatedCell value={row.paragraph_en} />,
    },
    {
      id: "paragraph_mm",
      label: "Paragraph (Myanmar)",
      render: (row) => <TruncatedCell value={row.paragraph_mm} myanmar />,
    },
  ];

  return (
    <DataListPage
      title="News Posts"
      rows={news || []}
      columns={columns}
      count={count}
      page={page}
      rowsPerPage={rowsPerPage}
      onPageChange={handleChangePage}
      onRowsPerPageChange={handleChangeRowsPerPage}
      createButton={{ label: "Create", onClick: () => navigate("/createNew") }}
      onView={openDetail}
      menuActions={[{ label: "View details", onClick: openDetail }]}
      loading={!news}
    />
  );
}
